export enum CampaignStatsColorHexaCodes {
  SCHEDULED = "#E6EBF1",
  RUNNING = "#235A96",
  COMPLETED = "#027A48",
  ERROR = "#F04438",
}
